// extracted by mini-css-extract-plugin
module.exports =  {"container":"SYTr8dhYEfY5QkiIfCtL","left":"FuwRWlDQ_b0UeFzUsUfw","right":"XqR9Pz66OP37Gbswn_aP"};